import { Badge } from '@any-ui-react/core';
import type { BadgeProps, DefaultMantineColor } from '@mantine/core';
import { EmployeeIdpStatus, type EmployeeIdpType } from '@/common/graphql';
import { EmployeeIdpStatusLabels, IDP_OCCURRENCE_COUNT } from '@/common/types';

const employeeIdpStatusColor: Record<EmployeeIdpStatus, DefaultMantineColor> = {
  [EmployeeIdpStatus.Draft]: 'yellow',
  [EmployeeIdpStatus.Reviewing]: 'blue',
  [EmployeeIdpStatus.OverdueReviewing]: 'red',
  [EmployeeIdpStatus.OverdueResult]: 'red',
  [EmployeeIdpStatus.CompletedSuccess]: 'green',
  [EmployeeIdpStatus.CompletedFailure]: 'pink',
  [EmployeeIdpStatus.Cancelled]: 'gray',
};

interface Props extends BadgeProps {
  status: EmployeeIdpStatus;
  reviewing?: {
    type: EmployeeIdpType;
    completedReviewCount: number;
  };
}

export const EmployeeIdpStatusBadge = ({ status, reviewing, ...rest }: Props) => (
  <Badge {...rest} color={employeeIdpStatusColor[status]}>
    {EmployeeIdpStatusLabels[status]}
    {reviewing &&
      (status === EmployeeIdpStatus.Reviewing || status === EmployeeIdpStatus.OverdueReviewing) &&
      ` (${Math.min(reviewing.completedReviewCount + 1, IDP_OCCURRENCE_COUNT[reviewing.type])} / ${IDP_OCCURRENCE_COUNT[reviewing.type]})`}
  </Badge>
);
